module.exports = __webpack_public_path__ + "static/tome_of_leadership_and_influence-d4bf94abf98014b3194bde3ceacd8764.jpeg";